export default function SecondOperation({auth, secondGrower, mobile}) {
  const checkPermission = auth.isAuthenticated && auth.user.role === "user" && secondGrower.length > 1;
  const classList = mobile
    ? "block rounded-md py-2 px-3 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"
    : "block py-2 px-4 text-sm text-gray-700";

  return checkPermission && (
    <a href="/betrieb" className={classList}>
      Betrieb auswählen
    </a>
  )
}
